// tokenHelper.js
import { jwtDecode } from "jwt-decode";

export function isTokenExpired() {
  const token = localStorage.getItem("token");
  if (!token) return true;

  try {
    const decoded = jwtDecode(token);
    const currentTime = Date.now() / 1000;
    return decoded.exp < currentTime || decoded.user != "USER"; // true → expired
  } catch (e) {
    return true; // token invalid
  }
}

export function isAdminTokenExpired() {
  const token = localStorage.getItem("token");
  if (!token) return true;

  try {
    const decoded = jwtDecode(token);
    const currentTime = Date.now() / 1000;

    return decoded.exp < currentTime || decoded.user != "ADMIN"; // true → expired
  } catch (e) {
    return true; // token invalid
  }
}
